import React from 'react'

/* filters: [
**   { name: "", slug: "", children: [] },
**   { name: "", slug: "", children: [{
**     { name: "", slug: "" }
**   }] }
*/

interface Filter {
  name: string
  slug: string
  children?: Filter[]
}

interface ScrollableFiltersProps {
  selected: any[]
  filters: Filter[]
  onFiltersChanged: (a: any[]) => void
}

interface ScrollableFiltersState {
  expanded: any[]
}

export default class ScrollableFilters extends React.Component<ScrollableFiltersProps, ScrollableFiltersState> {
  static get defaultProps() {
    return {
      selected: [],
      filters: [],
      onFiltersChanged: () => {}
    }
  }

  constructor(props) {
    super(props)

    this.setChecked = this.setChecked.bind(this)
    this.expand = this.expand.bind(this)
    this.collapse = this.collapse.bind(this)

    this.state = {
      expanded: []
    }
  }

  expand(slug) {
    this.setState({
      expanded: this.state.expanded.concat([slug])
    })
  }

  collapse(slug) {
    this.setState({
      expanded: this.state.expanded.filter(e => { return e != slug })
    })
  }

  setChecked(slug, checked) {
    if (checked) {
      this.props.onFiltersChanged(this.props.selected.concat([slug]))
    } else {
      const changed = this.props.selected.filter(c => { return c != slug })
      this.props.onFiltersChanged(changed)
    }
  }

  renderChildren(parent) {
    const children = parent.children.map(c => {
      return this.renderFilter(c)
    })

    return (
      <div className="filter-children">
        { children }
      </div>
    )
  }

  renderFilter(filter) {
    const self = this
    let expanded = this.state.expanded.filter(e => { return e === filter.slug }).length > 0
    const checked = this.props.selected.filter(c => { return String(c) === filter.slug }).length > 0

    let forceExpanded = false
    let canExpand = false
    if (filter.children && filter.children.length > 0) {
      canExpand = true
      
      const expandedChildren = filter.children.map(c => { return c.id }).filter(id => this.props.selected.includes(id))
      forceExpanded = expandedChildren.length > 0
    }

    return (
      <div key={filter.slug} className="filter">
        <label className="rs-checkbox rs-checkbox-checkbox">
          { filter.name }

          <input type="checkbox" checked={checked} onChange={(event) => {
            self.setChecked(filter.slug, event.target.checked)
          }} />

          <div className="rs-checkbox_indicator"></div>
        </label>

        { !forceExpanded && canExpand && !expanded ? <span className="filter-expand" onClick={() => {
          this.expand(filter.slug)}
        }>+</span> : undefined }

        { !forceExpanded && canExpand && expanded ? <span className="filter-expand" onClick={() => {
          this.collapse(filter.slug)}
        }>-</span> : undefined }

        { canExpand && (expanded || forceExpanded) ? this.renderChildren(filter) : undefined }
      </div>
    )
  }

  render() {
    const self = this
    const filters = this.props.filters.map(filter => {
      return self.renderFilter(filter)
    })

    return (
      <div className="scrollable-filters">
        { filters }
      </div>
    )
  }
}